import React from 'react'
import { Link } from 'react-router'

import logo from 'assets/images/logo-gc.png'

const Success = () => (
  <div>
    <div className="logo">
      <Link to="/">
        <img src={logo} style={{ width: '200px' }} alt="logo" />
      </Link>
    </div>
    <h3 className="form-title font-green">
      Register Success
    </h3>
    <h3>
      <small>
        <Link to="/" className="text-center font-dark" style={{ textDecoration: 'underline' }}>
          Sign In
        </Link>
      </small>
    </h3>
  </div>
)

export default Success
